import type { ReactNode } from 'react';

import type { UserRoleType } from '@/api/user';
import CheckmarkIcon from '@/assets/svg/bx-check.svg?react';
import { RadioGroupItem } from '@/components/Form';
import { Field, FieldContent, FieldDescription, FieldLabel } from '@/components/Form/fields';
import { cn } from '@/lib/utils';

type Props = {
  type: UserRoleType;
  isEditing: boolean;
  disabled: boolean;
  role: UserRoleType;
  title: ReactNode;
  description: ReactNode;
};

const PermissionItem = ({ type, isEditing, disabled, role, title, description }: Props) => {
  return (
    <Field orientation="horizontal">
      {isEditing ? (
        <RadioGroupItem value={type} id={type} disabled={disabled} />
      ) : (
        <CheckmarkIcon
          className={cn('-mt-0.5 size-6 text-green-400', { invisible: role !== type })}
        />
      )}
      <FieldContent>
        <FieldLabel className="text-base! font-semibold!" htmlFor={type}>
          {title}
        </FieldLabel>
        <FieldDescription>{description}</FieldDescription>
      </FieldContent>
    </Field>
  );
};

export default PermissionItem;
